export enum ProductTypes {
  DEFAULT = 'product',
  AFFILIATE = 'affiliateProduct',
}
